import axios from "axios";

import { AppDispatch } from "../../reducer/store";
import { getToken } from "../axiosToken";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const actionUnloadEmployeesList =  (data: any) => async (dispatch: AppDispatch) => {
     const { token } = await getToken();
     axios.defaults.headers.common["Authorization"] = token;
     try {
      const response = await axios.post(
         `${BASE_URL}/json/auth/employee/list`
       );
       console.log(response);
     } catch {

     }
  };

  export const actionGetEmployeesList =  (page: number, size: number) => async (dispatch: AppDispatch) => {
      const { token } = await getToken();
      axios.defaults.headers.common["Authorization"] = token;
      try {
       const response = await axios.post(
          `${BASE_URL}/json/auth/employee/list?size=50&page=0`,          
        );
        console.log(response);
      } catch {
 
      }
   };